import React from "react";

import Purchase from "./Purchase";
import Credit from "./Credit";
import Balloon from "./Balloon";
import Leasing from "./Leasing";

import { TVehicle } from "types";

import { normalizeType } from "helper/finance_helper";

interface IDetail {
  vehicle: TVehicle;
  financeRate?: any;
  short?: boolean;
}

const Detail: React.FC<IDetail> = ({
  vehicle,
  financeRate,
  short = false,
}): JSX.Element | null => {
  if (!financeRate?.type) return null;
  const type = normalizeType(financeRate.type);
  switch (type) {
    case "buy":
      return <Purchase {...{ vehicle, financeRate, short }} />;
    case "credit":
      return <Credit {...{ vehicle, financeRate, short }} />;
    case "balloon":
      return <Balloon {...{ vehicle, financeRate, short }} />;
    case "leasing":
      return <Leasing {...{ vehicle, financeRate, short }} />;
    default:
      return <></>;
  }
};

export default Detail;
